/**
 * This hook is designed designed to help with Voucher Permissions.
 *
 */

import { BaseRbacRole, User, ZeusRbacRole } from 'api/types/userApiTypes'
import { VoucherAction, VoucherStatus } from 'api/types/voucher/voucherEnums'
import { Voucher } from 'api/types/voucher/voucherSchemas'

import { StatusRole, statusRoleAction } from '../util/VoucherPermissionsUtil'

const isStatusRole = (role: ZeusRbacRole): role is StatusRole => {
  return (
    role === ZeusRbacRole.ZeusOperator ||
    role === ZeusRbacRole.ZeusAuditor ||
    role === ZeusRbacRole.ZeusApprover ||
    role === ZeusRbacRole.ZeusCertifier
  )
}

export const isActionAllowed = (user?: User, voucher?: Voucher, action?: VoucherAction) => {
  if (!user || !voucher || !action) {
    return false
  }

  /* Super Admins can do everything */
  if (user.role === BaseRbacRole.SuperAdmin) {
    return true
  }

  const isResponsibleOfficer = voucher.responsible_officer?.id === user.id
  const status = voucher.status as VoucherStatus
  /* # TODO: This is a temporary hack, should add this to the statusRoleAction map */
  const role =
    user.role === BaseRbacRole.Admin ? ZeusRbacRole.ZeusOperator : (user.role as ZeusRbacRole)
  if (isStatusRole(role)) {
    return statusRoleAction(isResponsibleOfficer)[status][role][action]
  }
  return false
}

export const useVoucherPermissions = () => {
  return {
    isActionAllowed,
  }
}
